import React from "react";

const JourneyLogoRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.7565 8.86047C15.2717 8.84141 14.7889 8.83505 14.3182 8.84564C14.8432 7.0368 16.2574 2.17156 16.2574 2.17156L16.3077 2H10.0092V3.17977H14.461L12.8416 8.93884C12.3769 8.98756 11.9163 9.05322 11.4737 9.1337C9.19652 9.56156 6.15691 10.6291 4.61599 13.2746C4.04066 14.2637 3.65241 15.8184 4.45908 16.9473C4.86342 17.5128 5.57354 17.8983 6.35808 17.9788C6.50292 17.9936 6.64574 18 6.78857 18C8.9169 18 10.7716 16.3966 11.8358 14.8186L11.8901 14.7382C13.0106 13.0458 13.6463 11.1565 14.121 9.52343C14.6139 9.46201 15.1269 9.41753 15.676 9.38364C15.6962 9.20572 15.7243 9.02992 15.7565 8.85623V8.86047ZM12.1878 11.0336C11.522 12.7874 10.7998 14.1112 9.92071 15.2041C9.42987 15.8141 8.92897 16.2568 8.38984 16.5597C7.553 17.0299 6.69201 17.1295 6.08852 16.8223C5.39048 16.4686 5.25368 15.6002 5.34823 14.9627C5.46893 14.1493 5.90546 13.48 6.25146 13.0627C7.59927 11.4297 9.68132 10.3516 12.6143 9.77125C12.4936 10.18 12.3528 10.5952 12.1878 11.0336Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(JourneyLogoRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;